export function mapApiInteractions(details = []) {
    return details.map((item) => {
      let parsed = {};
  
      try {
        parsed = JSON.parse(item.Interaction);
      } catch (e) {
        console.error("Interaction parse error", item);
      }

  
      const base = {
        id: item.InteractionId, // IMPORTANT for update/delete
        timeSec: parsed.StartTimeSec || 0,
        position: parsed.Position || { xPct: 50, yPct: 50 },
        backgroundImageUrl: parsed.BgImage || "",
        exampleImageUrl: parsed.Media || "",
        enableRetry: parsed.EnableRetry,
        showSolution: parsed.ShowSolution,
        InteractionStatus:item.VideoInteractionStatus
      };
  
      switch (item.VideoInteractionType) {
  
        case 1: // TrueFalse
          return {
            ...base,
            type: "true_false",
            prompt: parsed.QuestionText,
            revealText: parsed.FeedBackOnCorrectAnswer || "",
            correct: parsed.CorrectAnswer
          };
  
        case 2: // FillBlank
          return {
            ...base,
            type: "fill_blank",
            prompt: parsed.TemplateText,
            revealText: parsed.FeedBackOnCorrectAnswer || ""
          };
  
        case 3: // MultiChoice
        case 7: // SingleChoice
          return {
            ...base,
            type: "multiple_choice",
            prompt: parsed.QuestionText,
            selectionMode:
              item.VideoInteractionType === 3 ? "multiple" : "single",
            options: (parsed.Options || []).map((o) => ({
              text: o.optionText,
              isCorrect: o.correctAnswer,
              tipText: o.tipText || "",
              selectedFeedback: o.messageIfSelected || "",
              unselectedFeedback: o.messageIfNotSelected || ""
            }))
          };
  
        case 4: // DragDrop
          return {
            ...base,
            type: "drag_drop",
            prompt: parsed.QuestionText,
            slots: (parsed.DropZone || []).map((z) => z.Label),
            items: (parsed.DropElements || []).map((e) => e.Label),
            correctBySlot: (parsed.DropZone || []).map((z) => {
              const zoneId = z.Id;
              return (parsed.DropElements || [])
                .map((e, idx) => (e.DropZoneId === zoneId ? idx : null))
                .filter((v) => v !== null);
            })
          };
  
        case 5: // Hint
          return {
            ...base,
            type: "info_hint",
            prompt: parsed.Text,
            durationSec: parsed.EndTimeSec - parsed.StartTimeSec
          };
  
        case 6: // DragWords
          return {
            ...base,
            type: "word_bank_fill",
            prompt: parsed.Question,
            sentenceTemplate: parsed.QuestionText,
            correctWords: (parsed.CorrectWords || []).map((c) => c.Label),
            distractorWords: (parsed.Distractors || []).map((d) => d.Label)
          };
  
        default:
          return base;
      }
    });
  }
  